import locales from "./locales/locales";
import router from './routes/routes'

export const SecurityRolesModule = {
	name: 'securityRoles',
	routes: router,
	locales: locales,
}